var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25268 9.98685C4.99977 9.65495 6.59539 9.489 8.03951 9.489C9.48363 9.489 11.0792 9.65495 12.8263 9.98685C13.7391 10.1605 14.5648 10.6643 15.1592 11.4104C15.7537 12.1566 16.0792 13.0977 16.0791 14.0696V16.67H-6.09823e-05V14.0696C-0.000212482 13.0977 0.325336 12.1566 0.919795 11.4104C1.51425 10.6643 2.33989 10.1605 3.25268 9.98685ZM4.23234 3.7645C4.23234 1.68609 5.89562 0 7.948 0C9.99884 0 11.6621 1.68529 11.6621 3.7645C11.6621 5.84292 9.99884 7.52901 7.948 7.52901C5.89485 7.52901 4.23158 5.84372 4.23158 3.7645H4.23234Z",
    fill: "#273043"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.cf6a1c71bd3a625a676b9515f08b0650.svg";
export { ForwardRef as ReactComponent };